import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shareGoldMail",
  "use": "shareGoldMail-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"shareGoldMail\"><g fill=\"#9c7446\"><path d=\"m16 .5c-8.6 0-15.5 6.9-15.5 15.5s6.9 15.5 15.5 15.5 15.5-6.9 15.5-15.5-6.9-15.5-15.5-15.5zm7.5 18.5c0 1.1-.9 2-2 2h-11c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h11c1.1 0 2 .9 2 2z\" /><path d=\"m16 17.6-6.4-4.9c-.1.1-.1.2-.1.3v6c0 .6.4 1 1 1h11c.6 0 1-.4 1-1v-6c0-.1 0-.2-.1-.3z\" /><path d=\"m21.7 12h-.2-11-.2l5.7 4.4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol